import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useOnValueChange = <T>(value: T, callback: (current: T, previousValue: T | undefined) => void) => {
  const previousValue = usePrevious(value);

  useEffect(() => {
    if (value !== previousValue) {
      callback(value, previousValue);
    }
  }, [value, previousValue, callback]);
};
